import { useTheme } from '@mui/material';

export const useWebPlatformDimensions = () => {
  const theme = useTheme();

  return {
    headerHeight: theme.ifx.density['density-xl'],
    footerHeight: 30,
  };
};
